import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assests/logo.png';
import StoreButtons from './ui/StoreButtons';

function Footer() {
  return (
    <footer className="relative border-t border-white/[0.06] bg-charcoal">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_0%,rgba(216,27,96,0.08),transparent)]" aria-hidden />

      <div className="site-container relative py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Link to="/" className="mb-4 inline-flex items-center gap-2.5">
              <img src={logo} alt="Strapin" className="h-9 w-9 object-contain" />
              <span className="text-2xl font-black text-white">
                Strap<span className="text-primary">In</span>
              </span>
            </Link>
            <p className="mb-2 font-semibold text-mist">For queer people. Built by gay men.</p>
            <p className="mb-6 max-w-sm text-sm leading-relaxed text-silver">
              Privacy-first connection — screenshot protection, nearby discovery, private albums, and data practices you can read in plain language.
            </p>
            <StoreButtons size="md" />
          </div>

          <div className="lg:col-span-2">
            <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-primary">Legal</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/privacy" className="text-silver transition-colors hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/safety" className="text-silver transition-colors hover:text-primary">Safety Center</Link></li>
              <li><Link to="/terms" className="text-silver transition-colors hover:text-primary">Terms of Service</Link></li>
              <li><Link to="/child-safety" className="text-silver transition-colors hover:text-primary">Child Safety Standards</Link></li>
              <li><Link to="/account-deletion" className="text-silver transition-colors hover:text-primary">Account Deletion</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-secondary">Support</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/help" className="text-silver transition-colors hover:text-primary">Help Center</Link></li>
              <li><Link to="/support" className="text-silver transition-colors hover:text-primary">Contact Support</Link></li>
              <li><Link to="/download" className="text-silver transition-colors hover:text-primary">Download</Link></li>
              <li>
                <a href="mailto:support@strapinapp.com" className="text-silver transition-colors hover:text-primary">
                  support@strapinapp.com
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-accent">Follow</h4>
            <div className="flex gap-3">
              <a
                href="https://x.com/strapindating"
                className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.04] text-silver transition-all hover:border-primary/40 hover:text-primary"
                aria-label="Strapin on X"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/strapindating"
                className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.04] text-silver transition-all hover:border-primary/40 hover:text-primary"
                aria-label="Strapin on Instagram"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.467.398.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/[0.06] pt-8 text-center text-sm text-silver md:flex-row md:text-left">
          <p>&copy; 2026 Strapin. All rights reserved.</p>
          <p>Made for queer people who value privacy.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
